import type {
  VoicePromptResponseBody,
  VoicePromptType,
} from "../../Types/VoiceAssistant/VoiceAssistantTypes";

export const VOICE_AI_RESPONSE_EVENT = "rcm-voice-ai-response";

export type VoiceAiResponseDetail = {
  type: VoicePromptType;
  data: VoicePromptResponseBody["data"] | null;
  declaredFileType?: string | null;
};
